module.exports = __webpack_public_path__ + "img/icon-shipping-gift.b4ab951d.svg";